import { Player } from '@lottiefiles/react-lottie-player';
import successAnim from '../assets/Helper/Success animation.json';
import { CircleX } from 'lucide-react';
import { toast } from 'react-toastify';
import { getLocalStorage, getWithToken } from '../API/Api';
import { useContext, useEffect, useState } from 'react';
import { ProgressContext } from '../contexts/ProgressContext';
import THUNDERBOLT_ICON from '../assets/icons/ComniqaiIcon-V3.0/conversations-icon.svg';

export default function ProgressBar({ progress, urlStats }) {
  const { stopPolling, showPopup, setShowPopup } = useContext(ProgressContext);
  const [isCancelling, setIsCancelling] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isCancelled, setIsCancelled] = useState(() => localStorage.getItem('faqCancelled') === 'false');
  const [isPublishing, setIsPublishing] = useState(false);

  useEffect(() => {
    const handleStorage = () => {
      setIsCancelled(localStorage.getItem('faqCancelled') === 'false');
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  const handleCancel = async () => {
    if (isCancelling) return;

    const token = getLocalStorage('apiToken');
    if (!token) {
      toast.error('API token not found');
      return;
    }
    setIsCancelling(true);

    try {
      const response = await getWithToken('cancel_faq_generation', JSON.parse(token));

      if (response?.status === 200) {
        toast.success('FAQ generation cancelled successfully');
        // stopPolling();
        setShowPopup(false);

        setIsPopupOpen(false);
        setIsCancelled(true);
        localStorage.setItem('faqCancelled', 'true');
      } else {
        toast.error(response?.message || 'Failed to cancel FAQ generation');
      }
    } catch (error) {
      console.error('Cancel FAQ Error:', error);
      toast.error('Something went wrong');
    } finally {
      setIsCancelling(false);
    }
  };

  const publishChatbotData = async () => {
    const token = getLocalStorage('apiToken');
    if (!token) {
      toast.error('API token not found');
      return;
    }
    setIsPublishing(true);
    try {
      const response = await getWithToken('publish-data', JSON.parse(token));
      if (response.status === 200) {
        stopPolling();
        setShowPopup(false);
        toast.success(response?.message);
      } else {
        toast.error(response.message || 'Failed to publish chatbot');
      }
    } catch (error) {
      console.error('Error publishing chatbot:', error);
      toast.error('Something went wrong while publishing');
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <>
      {!showPopup ? (
        <div className='sidebar-progress-container'>
          <div className='progress-header d-flex align-items-center justify-content-between'>
            <span className='progress-title outfit-medium'>Training of links</span>
            {!isCancelled && <CircleX size={18} className='cursor-pointer text-white' title='Cancelling FAQ Generation' onClick={() => setIsPopupOpen(true)} />}
          </div>

          <div className='progress'>
            <div
              className={`progress-bar progress-bar-striped`}
              id='linearBar'
              role='progressbar'
              style={{ width: `${progress || 0}%` }}
              aria-valuenow={progress}
              aria-valuemin='0'
              aria-valuemax='100'
            >
              {progress || 0}%
            </div>
          </div>
        </div>
      ) : (
        <div className='progress-celebration z-10'>
          <Player autoplay loop keepLastFrame src={successAnim} style={{ height: '100px', width: '100%' }} />
          <p className='progress-percentage jump outfit-medium mb-0'>
            <span className='outfit-bold me-2'>{urlStats?.faq_count || '0'}</span>
            FAQs Generated
          </p>
          <button className='btn-generatedlead outfit-medium d-flex align-items-center gap-2 mt-3' disabled={isPublishing} onClick={() => publishChatbotData()}>
            {isPublishing ? (
              <>
                <span className='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span>
                Publishing...
              </>
            ) : (
              <>
                <img src={THUNDERBOLT_ICON} alt='thunderbolt-icon' />
                Publish Chatbot
              </>
            )}
          </button>
        </div>
      )}

      {isPopupOpen && (
        <div className='custom-popup'>
          <div className='popup-content text-start'>
            <div className={'popup-head mt-3 mb-4'}>
              <h4 className='outfit-medium'>Cancel FAQ Generation</h4>
            </div>
            <hr />
            <div className='popup-body'>
              <p className='outfit-regular text-muted small mb-0'>Are you sure you want to cancel the FAQ generation?</p>
            </div>
            <hr />
            <div className='popup-footer d-flex align-items-center gap-2'>
              <button
                className='btn-modal-save outfit-medium'
                style={{ background: 'rgb(220, 53, 69)', borderColor: 'rgb(220, 53, 69)' }}
                onClick={handleCancel}
                disabled={isCancelling}
              >
                {isCancelling ? 'Cancelling...' : 'Yes'}
              </button>
              <button className='btn-modal-cancel outfit-medium' data-dismiss='modal' onClick={() => setIsPopupOpen(false)}>
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
